export const API_URL = 'incidentCategories'
export const ROUTE_NAME = 'incidentCategories'
